import { TextPreset, TTextPreset } from '../types';

export const textPreset: Record<TTextPreset, string> = {
  [TextPreset.CUSTOM]: `text-preset__${TextPreset.CUSTOM}`,
  [TextPreset.SECTION_HEADER]: `text-preset__${TextPreset.SECTION_HEADER}`,
  [TextPreset.BLOCK_HEADER]: `text-preset__${TextPreset.BLOCK_HEADER}`,
  [TextPreset.SWITCHER_LABEL]: `text-preset__${TextPreset.SWITCHER_LABEL} ml-4`,
  [TextPreset.COLUMN_TITLE]: `text-preset__${TextPreset.COLUMN_TITLE}`,
  [TextPreset.LIST_ROW]: `text-preset__${TextPreset.LIST_ROW}`,
  [TextPreset.DONATABLE_IN_LIST]: `text-preset__${TextPreset.DONATABLE_IN_LIST}`,
  [TextPreset.ERROR]: `text-preset__${TextPreset.ERROR}`,
  [TextPreset.RECOMMENDATION]: `text-preset__${TextPreset.RECOMMENDATION}`,
  [TextPreset.CART_OPTION]: `text-preset__${TextPreset.CART_OPTION}`,
  [TextPreset.ORDER_FIELD]: `text-preset__${TextPreset.ORDER_FIELD}`,
  [TextPreset.MODAL_MESSAGE]: `text-preset__${TextPreset.MODAL_MESSAGE}`,
  [TextPreset.TITLE_INSIDE_INPUT]: `text-preset__${TextPreset.TITLE_INSIDE_INPUT} ml-4`,
};
